<template>
<CommonLoading
	v-if="loading"
/>
<div class="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
	<div class="sm:mx-auto sm:w-full sm:max-w-sm">
		<img class="mx-auto h-30 w-auto" src="../../assets/Siena_logo.png" alt="Your Company" />
	<h2 class="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">Justech V02</h2>
	</div>
	<div class="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
	<form class="space-y-6" action="#" method="POST">
		<div>
		<label for="email" class="block text-sm font-medium leading-6 text-gray-900">Email</label>
		<div class="mt-2">
			<input v-model="username" id="email" name="email" type="email" autocomplete="email" required class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-customPurple sm:text-sm sm:leading-6" />
		</div>
		</div>

		<div>
		<div class="flex items-center justify-between">
			<label for="password" class="block text-sm font-medium leading-6 text-gray-900">senha</label>
			<div class="text-sm">
			<a href="#" class="font-semibold text-customPurple hover:text-sienaBlue">esqueceu sua senha?</a>
			</div>
		</div>
		<div class="mt-2">
			<input v-model="password" id="password" name="password" type="password" autocomplete="current-password" required class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-customPurple sm:text-sm sm:leading-6" />
		</div>
		</div>

		<div>
		<button @click="login" type="submit" class="flex w-full justify-center rounded-md bg-customPurple px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-sienaBlue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-customPurple">login</button>
		</div>
	</form>
	<span class="mt-2 text-sm text-red-600 font-medium">{{ error }}</span>
	</div>
	</div>
</template>
<script>

import LoginService from '@/services/LoginRepository.vue';
import CommonLoading from '../generalcomponents/CommonLoading.vue';
import Swal from "sweetalert2";

export default {
  name: 'LoginComponent',
  data() {
    return {
		password: '',
		username: '',
		error: '',
		loading: false
    };
	},
	props: {
	},
	methods: {
		async login(e) {
			this.loading =true;
			e.preventDefault();
			const userLogin = new LoginService();
			const user = {
				password: this.password,
				username: this.username
			}
			try {
				const response = await userLogin.doLogin(user);
				if (response?.status === 200) {
					this.loading =false;
					const MyUser = response.data;
					window.localStorage.setItem("myUser", JSON.stringify(MyUser))
					window.localStorage.setItem("token", MyUser.token);
					this.$router.push({ path: 'maindash' });
				} else {
					this.error = response?.message;
					this.mostrarAlertaErro(this.error)
				}
			} catch (error) {
				this.loading =false;
				console.log(error)
				this.mostrarAlertaErro(error.response.data.error)
			}
		},
		mostrarAlertaErro(message) {
			Swal.fire({
				icon: 'error',
				title: 'Erro!',
				text: message,
				confirmButtonColor: '#3085d6', 
			});
		},
	},
	components:{
		CommonLoading
	},
	setup() {
		return {
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
.logo img{
  width: 220px;
  margin: auto;
  padding: 0;
}
</style>
